import { render, staticRenderFns } from "./NovoKitDinamico.vue?vue&type=template&id=1f84f9ae"
import script from "./NovoKitDinamico.vue?vue&type=script&lang=ts"
export * from "./NovoKitDinamico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports